<template>
    <div ref="loading">
		<div class="form-title">ĐĂNG NHẬP</div>
        <form @submit.prevent="checkAccount" class="main-form">
          <label for="username">Tên đăng nhập</label>
          <input v-model="username" type="text" id="username" placeholder="Nhập tên đăng nhập" 
		  	v-on:keypress="regex($event)" v-on:keyup="checkInput" @copy.prevent @paste.prevent maxlength="32"/>
          <small class="warning" v-show="showWarning">
			<img src="@/assets/images/warning.png" alt="" />{{ textWarinng }}
          </small>

          <a href="javascript:void(0)" class="btn-forget" @click="forgotPass">Quên tài khoản?</a>
        </form>
		
        <a href="javascript:void(0)" class="btn-next" :class="{ 'blur': blurBtnNext}" v-on="blurBtnNext ? { } : {click: checkAccount}">Đăng nhập</a>

        <div class="form-sign-in" >
          Bạn chưa có tài khoản? <a href="javascript:void(0)" @click="register">Đăng ký ngay</a>
        </div>
	</div>
</template>
<script>
import { useAuthStore } from "@/store";
export default {
	data() {
		return {
			username: useAuthStore().username || "",
			showWarning: false,
			textWarinng: "Tên đăng nhập hoặc số điện thoại không tồn tại",
			blurBtnNext : useAuthStore().username.length <= 0
		};
	},
	methods: {
		checkAccount() {
			if(this.blurBtnNext){
				return;
			}
			let loader = this.$loading.show({
				// Optional parameters
				container: this.$refs.loading,
				canCancel: false,
			});
			const authStore = useAuthStore();
			authStore.username = this.username;
			authStore.checkAccount()
				.then((response) => {
					loader.hide();
					if (response.ResponseCode > 0) {
						this.showWarning = false;
						this.$router.push({
							name: 'password',
							params: {}
						});
						return;
					}
					this.textWarinng = this.$t(`login.${response.ResponseCode}`, {}, response.Description);
					this.showWarning = true;
					return;
				})
				.catch((error) => {
					loader.hide();
					console.error(error);
					this.textWarinng = "Hệ thống đang bận vui lòng thử lại sau";
					this.showWarning = true;
				});
		},
		register(){
			this.$router.push({
				name: 'regusername',
                params: { }
			});
		},
		forgotPass(){
			this.$router.push({
				name: 'forgotpassdefault',
				params: {}
			});
		},
		checkInput(){
			if (this.username.length > 0) {
				this.blurBtnNext = false;
			}
			else{
				this.blurBtnNext = true;
			}
		},
		regex(e) {
			if(e.keyCode == 13) return true;
			let char = String.fromCharCode(e.keyCode); // Get the character
			let checkSo = /^[0-9]+$/.test(char);
			if(checkSo) return true;
			e.preventDefault();
		}
	}
	
};
</script>
<style>
</style>